import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Guid } from '../../shared/utils/guid';
import { UserSettingsService } from '../../user/services/user-settings.service';
import { UserSetting } from '../../user/models/user-setting';

export class SavedTrackingSearch {
    // UserSetting is set so it's possible to update the saved search, when that should be supported...
    constructor(public name: string, public params: any, public userSetting?: UserSetting) { }
}

@Injectable({
    providedIn: 'root'
})
export class SavedTrackingSearchService {

    userSettingKey = 'Saved_TrackingSearch_';
    userSettingGroupKey = 'Saved_TrackingSearches';

    saveSearchSubject: Subject<SavedTrackingSearch> = new Subject<SavedTrackingSearch>();
    public saveSearchObserver = this.saveSearchSubject.asObservable();

    constructor(private userSettingsService: UserSettingsService) { }

    public getSearches(): Promise<SavedTrackingSearch[]> {
        return this.userSettingsService.getUserSettingsByGroup(this.userSettingGroupKey).then((userSettings: UserSetting[]) => {
            const searches: SavedTrackingSearch[] = [];
            if (userSettings && userSettings.length > 0) {
                userSettings = userSettings.sort((us1, us2) => us1.Value1.localeCompare(us2.Value1));
                return userSettings.map(us => new SavedTrackingSearch(us.Value1, JSON.parse(us.Value2), us));
            }
            else {
                return Promise.resolve(searches);
            }
        });
    }

    public saveSearch(searchToSave: SavedTrackingSearch): Promise<void> {
        const userSetting = searchToSave.userSetting ||
            new UserSetting(this.userSettingKey + Guid.newGuid(), this.userSettingGroupKey, searchToSave.name, JSON.stringify(searchToSave.params));
        return this.userSettingsService.saveSingleSettings(userSetting).then(() => {
            this.saveSearchSubject.next(searchToSave);
        });
    }

    public deleteSearch(searchToDelete: SavedTrackingSearch): Promise<void> {
        if (searchToDelete.userSetting) {
            return this.userSettingsService.deleteSetting(searchToDelete.userSetting.Key, null);
        }
        else {
            return Promise.resolve();
        }
    }
}
